module.exports = __webpack_public_path__ + "static/fonts/SourceHanSansCN-Medium.0984ac6.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/SourceHanSansCN-Medium.otf
// module id = f7ge
// module chunks = 1